<div
  #view="cdkOverlayOrigin"
  class="h-full"
  cdkOverlayOrigin
>
  <flx-resources-page
    [showAddNew]="accessRights().canEdit"
    [showSearchInput]="true"
    [showMenu]="true"
    [trackAnalytics]="true"
    [resourceType]="ApplicationResourceType.Substitutiontag"
    [pageMenuItems]="importExportMenuItems()"
    [disableAddNew]="readOnly()"
    (searchQueryChange)="onSearchQueryChange($event)"
    (addNew)="openContentValueEditModal()"
    class="h-full"
    pageTitle="Substitution Tags"
    searchInputPlaceholder="Search by key or label"
  >
    <ng-container ngProjectAs="[flxResourcesPageBody]">
      <flx-resources-grid
        [items]="context().filteredSubstitutionTags"
        [loading]="loading()"
        [tableDef]="substitutionTagsTableDef()"
        [uniqueKeys]="['code']"
        class="h-full"
        emptyMsg="No substitution values found"
        data-testId="substitution-tags-table"
      >
      </flx-resources-grid>
    </ng-container>
  </flx-resources-page>
</div>

<p-menu
  #actionsMenuElement
  [popup]="true"
  styleClass="flx-prime-menu"
  flxMenuCloseOnClickOutside
  flxMenuOnShowAlignment
/>

<ng-template
  #resourceUsagesDelete
  let-data
>
  <flx-resource-usages-delete-confirmation
    [resourceUsages]="data.resourceUsages"
    (viewUsagesClicked)="
      openResourceUsagesModal(selectedSubstitutionTag(), 'fromDeleteConfirm', $event)
    "
  ></flx-resource-usages-delete-confirmation>
</ng-template>

<flx-overlay
  [overlayOrigin]="view"
  [(showOverlay)]="showAuditLogsOverlay"
>
  <div class="bg-white h-full">
    @if (showAuditLogsOverlay()) {
      <flx-audit-logs
        [initialQuery]="{
          component: ComponentTypeEnum.CONTENT_MANAGEMENT,
          element: ElementTypeEnum.SUBSTITUTION_TAG,
          identifier: selectedSubstitutionTag().valueId,
          appVersionId: appVersionId(),
        }"
        [resourceName]="selectedSubstitutionTag().code"
      />
    }
  </div>
</flx-overlay>
